import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

export const TYPE_TEXT_AREA = 'TYPE_TEXT_AREA';

/**
 * UI input
 * Display an input element according the selected mode
 * Props (parameters)
 * @param string id
 * @param string value
 * @param func onChange: funcion called by values changes in the input element
 * @param string label
 * @param func validate: function to validate the value
 * @param string errorMessage: error shown by validate function  = false
 * @param bool disabled
 * @param string type: [text, password]
 * @param number width
 * @param string mode
 */
export default class UiInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.state = {
      focus: false,
    };
  }

  onFocusIn() {
    this.setState({ focus: true });
  }

  onFocusOut() {
    this.setState({ focus: false });
  }

  render() {
    const {
      id,
      value,
      onChange,
      label,
      validate,
      errorMessage,
      disabled,
      type,
      width,
      mode,
    } = this.props;
    const { focus } = this.state;
    const colors = colorsModeUI(mode);
    const valueValid = validate ? validate() : true;
    let style = {
      color: colors.INPUT_COLOR,
      backgroundColor: colors.INPUT_BACKGROUND_COLOR,
      borderColor: focus
        ? colors.INPUT_FOCUS_BORDER_COLOR
        : colors.INPUT_BORDER_COLOR,
    };
    if (!valueValid) {
      style.borderColor = colors.ALARM_COLOR;
    }
    let styleLabel = {
      color: colors.INPUT_LABEL_COLOR,
    };
    if (disabled) {
      style = {
        color: colors.INPUT_DISABLED,
        backgroundColor: colors.INPUT_BACKGROUND_COLOR,
        borderColor: colors.INPUT_DISABLED,
      };
      styleLabel = {
        color: colors.INPUT_DISABLED,
      };
    }

    return (
      <Form.Field width={width !== null ? width : 16} className="ui-input">
        {label && (
          <span className="label-input" style={styleLabel}>
            {label}
          </span>
        )}
        {type === TYPE_TEXT_AREA ? (
          <textarea
            id={id}
            value={value}
            type={type}
            onChange={(event) => onChange(event, event.target.value, id)}
            placeholder=" "
            className={!valueValid ? 'error' : ''}
            disabled={disabled}
            style={style}
            onFocus={this.onFocusIn}
            onBlur={this.onFocusOut}
            rows={3}
          />
        ) : (
          <input
            id={id}
            value={value}
            type={type}
            onChange={(event) => onChange(event, event.target.value, id)}
            placeholder=" "
            className={!valueValid ? 'error' : ''}
            disabled={disabled}
            style={style}
            onFocus={this.onFocusIn}
            onBlur={this.onFocusOut}
          />
        )}
        {!valueValid && (
          <i
            className="remove icon form-control-feedback"
            style={{ color: colors.ALARM_COLOR }}
          />
        )}
        {!valueValid && errorMessage && (
          <span className="error-message" style={{ color: colors.ALARM_COLOR }}>
            {errorMessage}
          </span>
        )}
      </Form.Field>
    );
  }
}

UiInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  validate: PropTypes.func,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  width: PropTypes.number,
  mode: PropTypes.string,
};

UiInput.defaultProps = {
  value: '',
  onChange: null,
  label: null,
  validate: null,
  errorMessage: null,
  disabled: false,
  type: 'text',
  width: 16,
  mode: null,
};
